'use client';

import MetricLineChart from '../MetricLineChart';
import MetricGauge from '../MetricGauge';

// Sample data: Uptime percentage over time
const uptimeTrendData = [
  { name: 'Jan', uptime: 99.92 },
  { name: 'Feb', uptime: 99.95 },
  { name: 'Mar', uptime: 99.98 },
  { name: 'Apr', uptime: 99.97 },
  { name: 'May', uptime: 99.99 },
  { name: 'Jun', uptime: 99.96 },
];

// Sample data: Downtime by cause
const downtimeCausesData = [
  { name: 'Jan 15', duration: 12, cause: 'Database failover' },
  { name: 'Jan 22', duration: 9.6, cause: 'Deployment issue' },
  { name: 'Feb 08', duration: 5.2, cause: 'Network outage' },
  { name: 'Mar 12', duration: 2.8, cause: 'API timeout' },
  { name: 'Apr 03', duration: 7.1, cause: 'Cache failure' },
  { name: 'May 18', duration: 1.5, cause: 'Health check' },
];

export function SystemUptimeTrend() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">📈 System Uptime Trend</h3>
      <MetricLineChart
        data={uptimeTrendData}
        lines={[
          { dataKey: 'uptime', name: 'Uptime (%)', color: '#6FCF97' },
        ]}
        xAxisLabel="Month"
        yAxisLabel="Uptime (%)"
        targetLine={99.9}
        height={350}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Sample data showing consistent high availability between 99.92% and 99.99% over 6 months.
        The green line represents the three nines target (99.9%). Current performance exceeds
        industry standards for SaaS applications. May achieved four nines (99.99%).
      </p>
    </div>
  );
}

export function SystemUptimeGauge() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">🎯 Current Month Uptime</h3>
      <MetricGauge
        value={99.95}
        max={100}
        label="System Uptime"
        unit="%"
        ranges={[
          { min: 0, max: 99, color: '#EB5757', label: 'Poor' },
          { min: 99, max: 99.5, color: '#F2C94C', label: 'Fair' },
          { min: 99.5, max: 99.9, color: '#4A90E2', label: 'Good' },
          { min: 99.9, max: 100, color: '#6FCF97', label: 'Excellent' },
        ]}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Current month uptime of 99.95% is Excellent. This represents only 21.6 minutes of downtime
        for the entire month, well under the 99.9% SLA target (43.2 minutes max). Continue investment
        in redundancy and monitoring to maintain this level.
      </p>
    </div>
  );
}

export function SystemUptimeCalendar() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">📅 Incident History</h3>
      <MetricLineChart
        data={downtimeCausesData}
        lines={[
          { dataKey: 'duration', name: 'Downtime (minutes)', color: '#E89841' },
        ]}
        xAxisLabel="Date"
        yAxisLabel="Downtime Duration (minutes)"
        height={300}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Most incidents resolved within 10 minutes. Database failover on Jan 15 (12 minutes) was the
        longest incident. Trend shows decreasing incident duration and frequency—improved automation
        and monitoring paying off. Focus on preventing deployment issues (Jan 22) through better
        testing and staged rollouts.
      </p>
    </div>
  );
}
